export enum CookiesConstants {
  SM_PLANNER_COOKIE_NAME = `token_SM_PLANNER`,
  R_PLANNER_COOKIE_2FA = `token_R_PLANNER_2FA`,
}
